<!--
  POC: account recovery via face liveness. Plain (non-i18n) copy on purpose —
  same rationale as the /kyc-test harness: this is a developer verification
  page, not a client-facing screen. If this graduates into the real recovery
  flow, every string here must move to src/locale (en.json + pt.json).
-->
<div class="recovery-test">
  <header class="masthead">
    <h1>Account Recovery — Face Liveness</h1>
    <p class="sub">
      Prove you are the person on your document. Upload the document, then complete a
      live face check.
    </p>
  </header>

  <!-- 1. Reference face -->
  <section *ngIf="phase === 'upload'" class="card">
    <h2>1. Document</h2>
    <p>Upload a document showing your face (CNH, RG, passport).</p>

    <input
      type="file"
      accept="image/*"
      (change)="onFile($event)"
      data-testid="doc-upload"
      aria-label="Document image"
    />

    <img *ngIf="documentPreview" [src]="documentPreview" class="preview" alt="Document preview" />

    <button
      mat-raised-button
      color="primary"
      [disabled]="!documentImage"
      (click)="start()"
      data-testid="start-btn"
    >
      Start liveness check
    </button>
  </section>

  <!-- 2. Liveness -->
  <section *ngIf="phase === 'starting'" class="card centered">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Preparing the liveness session…</p>
  </section>

  <section *ngIf="phase === 'liveness'" class="card">
    <h2>2. Liveness check</h2>
    <div #livenessHost class="liveness-host" data-testid="liveness-host"></div>
  </section>

  <section *ngIf="phase === 'checking'" class="card centered">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Matching your face against the document…</p>
  </section>

  <!-- 3. Verdict -->
  <section *ngIf="phase === 'result'" class="card" data-testid="result">
    <h2 [class.pass]="result?.decision === 'pass'" [class.fail]="result?.decision !== 'pass'">
      {{ result?.decision === 'pass' ? 'Access granted' : 'Not recognized' }}
    </h2>

    <dl class="scores">
      <dt>Liveness confidence</dt>
      <dd>{{ result?.livenessConfidence | number: '1.0-1' }}</dd>

      <dt>Face similarity</dt>
      <dd>{{ result?.similarity == null ? 'n/a' : (result?.similarity | number: '1.0-1') }}</dd>

      <dt>Reason</dt>
      <dd>{{ result?.reason }}</dd>
    </dl>

    <p class="note">POC only — no session is issued.</p>
    <button mat-button (click)="reset()" data-testid="retry-btn">Try again</button>
  </section>

  <section *ngIf="phase === 'error'" class="card" data-testid="error">
    <h2 class="fail">{{ error?.summary }}</h2>

    <ul class="error-detail" data-testid="error-detail">
      <li *ngFor="let line of error?.detail">{{ line }}</li>
    </ul>

    <p *ngIf="error?.hint" class="hint" data-testid="error-hint">
      <strong>Likely cause:</strong> {{ error?.hint }}
    </p>

    <p class="note">The full error object is in the browser console.</p>
    <button mat-button (click)="reset()" data-testid="retry-btn">Try again</button>
  </section>
</div>
